import styled from 'styled-components';

export const $RadioButtonGroup = styled.div`
  margin-bottom: 1.1rem;
`;
